import { render, staticRenderFns } from "./BottomTabbar.vue?vue&type=template&id=bf088f96&scoped=true&"
import script from "./BottomTabbar.vue?vue&type=script&lang=ts&"
export * from "./BottomTabbar.vue?vue&type=script&lang=ts&"
import style0 from "./BottomTabbar.vue?vue&type=style&index=0&id=bf088f96&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf088f96",
  null
  
)

export default component.exports